// TODO: Remove once onboarding has been tested with real users
export const ONBOARDING_SPLASH_ENABLED = true
